import React from 'react';
import { map, isEmpty, get, reduce, each, includes, join } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { mapProps, compose, onlyUpdateForKeys, withHandlers } from 'recompose';
import { VXCurrentFilters } from '../../visions/vx-current-filters';

const DATE_RANGE_FILTER = 'DATE_RANGE';

const AppliedFilters = (props) => {
  return (
    <div className="tag-info">
      <div className="records">
        {props.isFething
          ? <FormattedMessage id="tag.info.fetching"/>
          : <FormattedMessage id="tag.info.count" values={{ count: get(props, 'responseInfo.total', 0) }}/>}
      </div>
      {!isEmpty(props.filters) &&
      <div className="usedfilters m10-btm">
        <VXCurrentFilters
          filters={props.filters}
          onRemoveValues={props.onRemoveValues}
          onRemoveAll={props.resetSelection}
          translations={{
            clearAllLabel: <FormattedMessage id="filters.applied.cleatAll"/>
          }}
        />
      </div>}
    </div>
  )
};

export default compose(
  onlyUpdateForKeys(['isFething', 'responseInfo']),
  withHandlers({
    onRemoveValues: ({ onFacetSelectionChange, updateRecallsDates }) => (facetKey, values) => {
      if (facetKey === DATE_RANGE_FILTER) {
        updateRecallsDates([]);
      } else {
        onFacetSelectionChange({ key: facetKey }, get(values, '[0]'));
      }
    }
  }),
  mapProps(props => {
    const {
      selectedFacets,
      availableFacets,
      resetSelection,
      onRemoveValues,
      responseInfo,
      isFething,
      dates,
    } = props;

    const filters = reduce(selectedFacets, (facetsAgg, facetValueIds, facetKey) => {
      const storeFacet = get(availableFacets, facetKey);
      if (!isEmpty(storeFacet) && !isEmpty(facetValueIds)) {
        const facetData = get(storeFacet, 'data');
        const selectedValues = browseTree(facetData, facetProc(facetValueIds), {});
        facetsAgg.push({
          id: facetKey,
          label: <FormattedMessage id={get(storeFacet, 'conf.intl.title')}/>,
          values: map(selectedValues, x => x),
        });
      }
      return facetsAgg;
    }, []);

    if (!isEmpty(dates)) {
      const dateFilter = {
        id: DATE_RANGE_FILTER,
        label: <FormattedMessage id="filter.date"/>,
        values: [{
          id: DATE_RANGE_FILTER,
          label: join(map(dates, date => get(date, '_i')), ' - '),
        }]
      };
      filters.unshift(dateFilter);
    }

    return {
      filters,
      resetSelection,
      onRemoveValues,
      responseInfo,
      isFething,
    };
  })
)(AppliedFilters);


function browseTree(tree, proc, _acc) {
  let acc = { ..._acc };
  each(tree, (node) => {
    acc = proc(acc, node);
    if (node.childNodes) acc = browseTree(node.childNodes, proc, acc);
  });
  return acc;
}

function facetProc(facetIds) {
  return function (acc, node) {
    if (includes(facetIds, node.id)) return { ...acc, [node.id]: node };
    return acc;
  }
}



// WEBPACK FOOTER //
// ./src/views/recalls-list/facets/applied-filters.js